import OpenCallResults from '../components/OpenCallResults';
import PageLayout from '../components/pageLayout';

function OpenCallResultsPage() {
    return (
        <PageLayout children={<OpenCallResults />} />
    );
}

export default OpenCallResultsPage;
